// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MaxWidthWrap-module--wrap--1zwa-","wrapBig":"MaxWidthWrap-module--wrapBig--qyDgD","wrapSmaller":"MaxWidthWrap-module--wrapSmaller--2YOjY"};